// extracted by mini-css-extract-plugin
export default {"card":"X5-z"};